import { useTranslation } from 'react-i18next';
import { locations } from 'services/routes/locations';
import loudlyLogo from 'assets/images/loudly_type_2020_wht.svg';
import { StyledLink } from './styled';

type PropsType = {
  onClick?: () => void;
};

const CompanyLogo = ({ onClick }: PropsType) => {
  const { t } = useTranslation();

  return (
    <StyledLink
      data-testid="loudlyLogo"
      to={locations.general.discovery.pathname}
      onClick={onClick}
    >
      <img
        src={loudlyLogo}
        alt={t('general:image:alt')}
        title={t('general:image:title')}
        loading="lazy"
      />
    </StyledLink>
  );
};

export default CompanyLogo;
